import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { SelectInput } from '@core/components/Select';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { FormControl, Grid } from '@material-ui/core';
import { AnexoUnico } from 'app/components/Anexo';
import conciliacaoApi from 'app/services/api/conciliacaoApi';
import { contaApi } from 'app/services/api/contaApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import InformativoOnboarding from '../../../onboarding/components/InformativoOnboarding';
import { ConciliacaoContext } from '../ConciliacaoContext';
import { ConciliacaoModal } from './ConciliacaoModal';

const ImportarArquivoModal = ({ formikFiltro, leituraArquivo }) => {
  const [modal, setModal] = useContext(ConciliacaoContext).modal;
  const [arquivo, setArquivo] = useContext(ConciliacaoContext).arquivo;
  const [, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;
  const [searchConciliacoes, setSearchConciliacoes] = useContext(ConciliacaoContext).searchConciliacoes;
  const [, setSelecao] = useContext(ConciliacaoContext).selecao;
  const [, setCredito] = useContext(ConciliacaoContext).credito;
  const [, setDebito] = useContext(ConciliacaoContext).debito;
  const [, setSaldoFinal] = useContext(ConciliacaoContext).saldoFinal;
  const [, setConciliacoesPendentes] = useContext(ConciliacaoContext).conciliacoesPendentes;
  const [loading, setLoading] = useState(false);
  const [, setContaBancaria] = useContext(ConciliacaoContext).contaBancaria;

  const filtro = useRef({});
  const CONCILIACAO = 'Conciliação';

  useReduxLoading(loading);

  const extensoesPermitidas = ['ofx', 'ofc'];
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showMessage = (message, variant) => {
    dispatch(
      Actions.showMessage({
        message,
        variant,
      })
    );
  };

  const close = () => {
    setArquivo({});
    formik.resetForm(formik.initialValues);
    setModal('');
  };

  const handleCloseModal = () => {
    close();
  };

  const getInitialValues = (registro) => ({
    ...registro,
    id: registro?.id,
    arquivo: registro?.arquivo,
    tipoContaBancaria: registro?.tipoContaBancaria || 'CORRENTE',
  });

  const buscarLancamentosArquivo = async (filtro, search = searchConciliacoes) => {
    try {
      setSelecao([]);
      setConciliacoes([]);
      setCredito(0);
      setDebito(0);
      setSaldoFinal(0);
      setConciliacoesPendentes(0);

      const resp = await conciliacaoApi.buscarLancamentos(filtro);

      setSearchConciliacoes({
        size: resp.data.lancamentoExtratoBancarioResponse.size,
        page: resp.data.lancamentoExtratoBancarioResponse.number,
        totalElements: resp.data.lancamentoExtratoBancarioResponse.totalElements,
        sort: searchConciliacoes?.sort,
      });

      if (resp.data.lancamentoExtratoBancarioResponse) {
        setConciliacoes(resp.data.lancamentoExtratoBancarioResponse.content);
        setCredito(filtro?.situacao === 'CONCILIADO' ? 0 : Math.abs(resp.data.creditoDiferenca));
        setDebito(filtro?.situacao === 'CONCILIADO' ? 0 : Math.abs(resp.data.debitoDiferenca));
        setSaldoFinal(filtro?.situacao === 'CONCILIADO' ? 0 : resp.data.saldoFinal);
        setConciliacoesPendentes(filtro?.situacao === 'CONCILIADO' ? 0 : resp.data.conciliacoesPendentes);
      } else {
        setConciliacoes([]);
        showMessage('Nenhum registro foi encontrado.', 'error');
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    }
  };

  async function resetarFiltroArquivo() {
    formikFiltro.setFieldValue('conta', undefined);
    formikFiltro.setFieldValue('dataInicio', undefined);
    formikFiltro.setFieldValue('dataFim', undefined);
    formikFiltro.setFieldValue('tipo', 'TODOS');
    formikFiltro.setFieldValue('situacao', 'NAO_CONCILIADO');
  }

  const atualizarFiltroArquivo = async (res) => {
    filtro.current = {
      ...filtro.current,
      contaId: res?.data.filtro?.contaId,
      contaBancariaId: res?.data.filtro?.contaBancariaId,
      bancoId: res?.data.filtro?.bancoId,
      contaBancariaNomeReferencia: res?.data.filtro?.contaBancariaNomeReferencia,
      contaBancariaAgencia: res?.data.filtro?.contaBancariaAgencia,
      contaBancariaConta: res?.data.filtro?.contaBancariaConta,
      dataInicio: res.data.filtro?.dataInicio,
      dataFim: res.data.filtro?.dataFim,
      tipo: res.data.filtro?.tipo || 'TODOS',
      situacao: res.data.filtro?.situacao || 'NAO_CONCILIADO',
    };

    const conta = await contaApi.getOne(res.data.filtro.contaId);

    formikFiltro.setFieldValue('conta', conta.data);
    formikFiltro.setFieldValue('dataInicio', moment(filtro.current.dataInicio));
    formikFiltro.setFieldValue('dataFim', moment(filtro.current.dataFim));
    formikFiltro.setFieldValue('tipo', 'TODOS');
    formikFiltro.setFieldValue('situacao', 'NAO_CONCILIADO');

    let contaTipo;

    if (conta.data.id !== undefined && conta.data.id !== null) {
      if (conta.data.tipo === 'CONTA_CORRENTE') {
        contaTipo = 'Conta corrente';
      } else if (conta.data.tipo === 'CONTA_POUPANCA') {
        contaTipo = 'Conta poupança';
      } else {
        contaTipo = 'Conta investimento';
      }

      setContaBancaria({
        contaDescricao: conta.data.descricao,
        contaId: conta.data.id,
        contaBancariaNomeReferencia: conta.data.contaBancaria?.banco?.nome,
        contaBancariaAgencia: conta.data.contaBancaria?.agencia + '-' + conta.data.contaBancaria?.agenciaDigito,
        contaBancariaConta: conta.data.contaBancaria?.numeroConta + '-' + conta.data.contaBancaria?.contaDigito,
        contaTipo: contaTipo,
      });
    }
  };

  const handleUpload = async (file, tipoContaBancaria) => {
    if (file) {
      try {
        const arquivo = Object.assign(file, {
          id: undefined,
          nome: file.name,
          contentType: file.type,
        });

        const extensao = arquivo.nome.substring(arquivo.nome.lastIndexOf('.') + 1);

        if (!extensoesPermitidas.includes(extensao.toLowerCase())) {
          setArquivo([]);
          showMessage(
            'O formato do arquivo enviado é inválido. Favor informar um arquivo com extensão .OFC ou .OFX.',
            'error'
          );
        } else {
          await resetarFiltroArquivo();
          const formData = new FormData();
          formData.append('empresaId', getEmpresaContexto());
          formData.append('extrato', arquivo);
          formData.append('tipoContaBancaria', tipoContaBancaria);

          eventReactGA(CONCILIACAO, 'Importar arquivo');
          const res = await conciliacaoApi.uploadArquivo(formData);

          await atualizarFiltroArquivo(res);

          await buscarLancamentosArquivo(filtro.current);
        }
      } catch (err) {
        apiUtils.handleApiError(err);
      }
    }
  };

  const onSubmitForm = async () => {
    setLoading(true);

    leituraArquivo.current = true;

    await handleUpload(arquivo, formik.values.tipoContaBancaria);

    setArquivo({});
    formik.resetForm(formik.initialValues);

    setModal('');

    leituraArquivo.current = false;
    setLoading(false);
  };

  const ImportarArquivoSchema = yup.object().shape({
    arquivo: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('o arquivo')),
  });

  const formik = useFormik({
    initialValues: getInitialValues(arquivo),
    validationSchema: ImportarArquivoSchema,
    onSubmit: onSubmitForm,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const _errors = {
    arquivo: (formik?.submitCount > 0 || formik?.touched?.arquivo) && formik?.errors?.arquivo,
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];

    console.log(file);

    formik.handleChange({
      target: {
        id: 'arquivo',
        value: file,
      },
    });

    setArquivo(file);
  };

  return (
    <>
      <SimpleDialog open={modal === ConciliacaoModal.importarArquivo} onClose={handleCloseModal}>
        <FormikProvider value={formik}>
          <FormDialogContent
            onSubmit={formik.handleSubmit}
            header={{
              title: 'Importar arquivo',
              toolbar: (
                <>
                  <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                    Fechar
                  </CancelButton>
                  <SaveButton color="buttonSave" type="submit">
                    Processar
                  </SaveButton>
                </>
              ),
            }}
            content={
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl variant="outlined" style={{ width: '100%' }}>
                    <AnexoUnico
                      id="arquivo"
                      name="arquivo"
                      label="Arquivo"
                      placeholder="Selecione arquivo para conciliação (*OFX, *OFC.)"
                      required
                      onFileChange={onFileChange}
                      onBlur={formik.handleBlur}
                      arquivo={arquivo}
                      error={_errors.arquivo}
                      touched={!!_errors.arquivo}
                      accept=".OFX,.OFC"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <SelectInput
                    id="tipoContaBancaria"
                    label="Tipo da conta bancária"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.tipoContaBancaria}
                    options={[
                      { id: 'CORRENTE', title: 'Conta corrente' },
                      { id: 'POUPANCA', title: 'Conta poupança' },
                      { id: 'INVESTIMENTO', title: 'Conta investimento' },
                    ]}
                    disableClearable
                  />
                </Grid>
                <Grid item xs={12}>
                  <InformativoOnboarding titulo="Onde posso encontrar o arquivo OFX ou OFC">
                    O arquivo OFX ou OFC é fornecido pelo seu banco. Acesse a sua conta, busque o extrato do período
                    desejado para conciliação e faça o download do arquivo em um desses formatos.
                    <br />
                    <br />O sistema fará a leitura dos dados deste arquivo para fazer a conciliação automática.
                  </InformativoOnboarding>
                </Grid>
              </Grid>
            }
          />
        </FormikProvider>
      </SimpleDialog>
    </>
  );
};

export default ImportarArquivoModal;
